import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Card, Button, Form, InputGroup, Spinner, Modal } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchSuperAdminOrganizations, suspendOrganization, fetchSubscriptionPlans, fetchOrganizationsTree } from '../../../actioncreators/actioncreators';
import './SuperAdmin.css';

// Icons
const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

const BuildingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
  </svg>
);

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  </svg>
);

const SuspendIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>
  </svg>
);

const ActivateIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
  </svg>
);

const ChevronLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
  </svg>
);

const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
  </svg>
);

// Read navigation state synchronously before first render so the initial
// fetch already carries the correct filter — avoids a second fetch race.
const getInitialQuery = (navState) => {
  const base = { search: '', status: '', plan: '', page: 1, limit: 10 };
  if (!navState) return base;
  if (navState.filterType === 'status') return { ...base, status: navState.filterValue || '' };
  if (navState.filterType === 'plan') return { ...base, plan: navState.filterValue || '' };
  return base;
};

const OrganizationList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // All query params in one object so every state update is atomic — a single
  // setQuery({ ...prev, status: 'ACTIVE', page: 1 }) call never produces an
  // intermediate render where status changed but page hasn't yet.
  const [query, setQuery] = useState(() => getInitialQuery(location.state));
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [suspendReason, setSuspendReason] = useState('');
  const [availablePlans, setAvailablePlans] = useState([]);
  const abortRef = useRef(null);

  // Hierarchy tree: shown when NO search/status/plan filter is active, so the
  // Super Admin sees org -> child orgs -> sub-orgs nested. When a filter IS
  // active we fall back to the existing flat paginated list (server-filtered).
  const [orgTree, setOrgTree] = useState([]);
  const [treeLoading, setTreeLoading] = useState(true);
  const [expandedNodes, setExpandedNodes] = useState({}); // nodeKey -> bool

  // Clear navigation state after reading so it doesn't re-trigger on re-renders
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchSubscriptionPlans()
      .then(res => setAvailablePlans(Array.isArray(res.data?.data) ? res.data.data : []))
      .catch(() => {});
  }, []);

  // Fetch the hierarchy tree (used for the default, unfiltered view). Kept in a
  // callback so it can be re-run after a suspend/activate action.
  const loadTree = useCallback(async () => {
    setTreeLoading(true);
    try {
      const res = await fetchOrganizationsTree();
      setOrgTree(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) {
      setOrgTree([]);
    } finally {
      setTreeLoading(false);
    }
  }, []);

  useEffect(() => { loadTree(); }, [loadTree]);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    const run = async () => {
      setLoading(true);
      try {
        const response = await fetchSuperAdminOrganizations({
          search: query.search,
          status: query.status,
          plan: query.plan,
          page: query.page,
          limit: query.limit,
        });
        if (controller.signal.aborted) return;
        const data = response.data?.data || {};
        const newTotal = data.total || 0;
        // Prefer total_pages from backend; fall back to client calculation
        const newTotalPages = data.total_pages
          ? data.total_pages
          : Math.ceil(newTotal / query.limit) || 1;
        setOrganizations(data.organizations || []);
        setTotal(newTotal);
        setTotalPages(newTotalPages);
        // Clamp page if the filter narrowed results below the current page
        if (query.page > newTotalPages && newTotalPages > 0) {
          setQuery(prev => ({ ...prev, page: newTotalPages }));
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error('Failed to fetch organizations:', error);
        setOrganizations([]);
        setTotal(0);
        setTotalPages(1);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    run();
    return () => controller.abort();
  }, [query]);

  const handleSearchChange = useCallback((value) => {
    setQuery(prev => ({ ...prev, search: value, page: 1 }));
  }, []);

  const handleStatusChange = useCallback((value) => {
    setQuery(prev => ({ ...prev, status: value, page: 1 }));
  }, []);

  const handlePlanChange = useCallback((value) => {
    setQuery(prev => ({ ...prev, plan: value, page: 1 }));
  }, []);

  const handlePageChange = useCallback((newPage) => {
    setQuery(prev => ({ ...prev, page: newPage }));
  }, []);

  const handleClearFilters = useCallback(() => {
    setQuery(prev => ({ ...prev, search: '', status: '', plan: '', page: 1 }));
  }, []);

  const handleSuspend = async () => {
    if (!selectedOrg) return;
    try {
      await suspendOrganization(
        selectedOrg.org_id,
        selectedOrg.is_suspended ? 'ACTIVATE' : 'SUSPEND',
        suspendReason
      );
      setShowSuspendModal(false);
      setSuspendReason('');
      // Refresh current page without resetting pagination
      setQuery(prev => ({ ...prev }));
      // Also refresh the tree so its status badge reflects the change.
      loadTree();
    } catch (error) {
      console.error('Failed to suspend/activate organization:', error);
    }
  };

  const openSuspendModal = (org) => {
    setSelectedOrg(org);
    setShowSuspendModal(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      month: 'short', day: 'numeric', year: 'numeric',
      timeZone: 'Asia/Kolkata',
    });
  };

  const getStatusBadge = (org) => {
    if (org.is_suspended) return <span className="status-pill status-suspended">Suspended</span>;
    if (org.status === 'ACTIVE') return <span className="status-pill status-active">Active</span>;
    return <span className="status-pill status-inactive">Inactive</span>;
  };

  const getPlanBadge = (plan, planType) => {
    // The highlight color must key off the plan TYPE (Trial/Basic/Advance),
    // not the display name -- a custom-named package on an Advance-type plan
    // (e.g. "CustomSMKC") has no matching CSS class under its own name and
    // would otherwise render with no highlight at all.
    const cls = (planType || plan)?.toLowerCase() || 'default';
    return <span className={`plan-pill plan-${cls}`}>{plan || 'N/A'}</span>;
  };

  // Recursively render tree rows. `node.type` is "org" or "sub_org"; org nodes
  // carry the tab columns (plan/users/created), sub-org nodes show N/A there.
  const renderTreeRows = (nodes, depth = 0) => {
    const rows = [];
    for (const node of nodes) {
      const key = `${node.type}:${node.sub_org_id || node.org_id}`;
      const kids = node.children || [];
      const hasKids = kids.length > 0;
      const isExpanded = expandedNodes[key] !== false; // expanded by default
      const isSubOrg = node.type === 'sub_org';
      // Adapt the flat row's shape so getStatusBadge works on a node too.
      const nodeForBadge = { is_suspended: node.is_suspended, status: node.status };

      rows.push(
        <tr key={key} className={isSubOrg ? 'tree-row-suborg' : 'tree-row-org'}>
          <td>
            <div className="org-cell" style={{ paddingLeft: depth * 22 }}>
              {hasKids ? (
                <button
                  type="button"
                  className="tree-toggle"
                  onClick={() => setExpandedNodes(prev => ({ ...prev, [key]: !isExpanded }))}
                  title={isExpanded ? 'Collapse' : 'Expand'}
                >
                  {isExpanded ? '▾' : '▸'}
                </button>
              ) : (
                <span className="tree-toggle-spacer" />
              )}
              <div className="org-avatar">{node.name?.charAt(0)?.toUpperCase() || 'O'}</div>
              <div className="org-info">
                <span className="org-name">
                  {node.name}
                  {isSubOrg && <span className="tree-badge-suborg">Sub-Org</span>}
                </span>
                <span className="org-id">{node.sub_org_id || node.org_id}</span>
              </div>
            </div>
          </td>
          <td>{isSubOrg ? <span className="text-muted">—</span> : getPlanBadge(node.package_name, node.plan_type)}</td>
          <td>{getStatusBadge(nodeForBadge)}</td>
          <td>
            {isSubOrg ? <span className="text-muted">—</span> : (
              <div className="users-cell"><UsersIcon /><span>{node.user_count || 0}</span></div>
            )}
          </td>
          <td>
            {isSubOrg ? <span className="text-muted">—</span> : (
              <div className="date-cell"><CalendarIcon /><span>{formatDate(node.creation_date_and_time)}</span></div>
            )}
          </td>
          <td>
            {/* Org-level actions only on org nodes; sub-orgs are managed elsewhere. */}
            {!isSubOrg && (
              <div className="action-buttons">
                <button
                  className="action-btn-icon btn-view"
                  onClick={() => navigate(`/home/super-admin/organizations/${node.org_id}`)}
                  title="View Details"
                >
                  <EyeIcon />
                </button>
                <button
                  className={`action-btn-icon ${node.is_suspended ? 'btn-activate' : 'btn-suspend'}`}
                  onClick={() => openSuspendModal({
                    org_id: node.org_id, org_name: node.name, is_suspended: node.is_suspended,
                  })}
                  title={node.is_suspended ? 'Activate' : 'Suspend'}
                >
                  {node.is_suspended ? <ActivateIcon /> : <SuspendIcon />}
                </button>
              </div>
            )}
          </td>
        </tr>
      );
      if (hasKids && isExpanded) {
        rows.push(...renderTreeRows(kids, depth + 1));
      }
    }
    return rows;
  };

  const hasActiveFilter = query.search || query.status || query.plan;
  const firstRecord = total === 0 ? 0 : (query.page - 1) * query.limit + 1;
  const lastRecord = Math.min(query.page * query.limit, total);
  const isFirstPage = query.page === 1;
  const isLastPage = query.page >= totalPages;

  return (
    <div className="super-admin-page">
      {/* Header */}
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-icon"><BuildingIcon /></div>
          <div>
            <h1 className="page-title">Organizations</h1>
            <p className="page-subtitle">{total} total organizations</p>
          </div>
        </div>
        <Button className="btn-create" onClick={() => navigate('/home/super-admin/organizations/create')}>
          <PlusIcon /><span>Create Organization</span>
        </Button>
      </div>

      {/* Filters */}
      <Card className="filter-card">
        <Card.Body>
          <div className="filter-row">
            <div className="filter-col-search">
              <InputGroup className="search-input-group">
                <InputGroup.Text><SearchIcon /></InputGroup.Text>
                <Form.Control
                  placeholder="Search by name, email, or ID..."
                  value={query.search}
                  onChange={(e) => handleSearchChange(e.target.value)}
                />
              </InputGroup>
            </div>
            <div className="filter-col-select">
              <Form.Select
                className="filter-select"
                value={query.status}
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
                <option value="SUSPENDED">Suspended</option>
              </Form.Select>
            </div>
            <div className="filter-col-select">
              <Form.Select
                className="filter-select"
                value={query.plan}
                onChange={(e) => handlePlanChange(e.target.value)}
              >
                <option value="">All Plans</option>
                {availablePlans.map(p => (
                  <option key={p.package_id} value={p.package_name}>
                    {p.package_name}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="filter-col-clear">
              {hasActiveFilter && (
                <button className="btn-clear-filters" onClick={handleClearFilters}>
                  Clear
                </button>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Hierarchy tree view (default, when no filter is active) */}
      {!hasActiveFilter ? (
        <Card className="table-card">
          {treeLoading ? (
            <div className="loading-container">
              <Spinner animation="border" />
              <span className="loading-text">Loading organizations...</span>
            </div>
          ) : orgTree.length === 0 ? (
            <div className="empty-state">
              <BuildingIcon />
              <p>No organizations found.</p>
            </div>
          ) : (
            <div className="table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Organization</th>
                    <th>Plan</th>
                    <th>Status</th>
                    <th>Users</th>
                    <th>Created</th>
                    <th className="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>{renderTreeRows(orgTree)}</tbody>
              </table>
            </div>
          )}
        </Card>
      ) : (
      /* Flat, server-paginated list (when a search/status/plan filter is active) */
      <Card className="table-card">
        {loading ? (
          <div className="loading-container">
            <Spinner animation="border" />
            <span className="loading-text">Loading organizations...</span>
          </div>
        ) : organizations.length === 0 ? (
          <div className="empty-state">
            <BuildingIcon />
            <p>{hasActiveFilter ? 'No organizations match the selected filters.' : 'No organizations found.'}</p>
          </div>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Organization</th>
                    <th>Plan</th>
                    <th>Status</th>
                    <th>Users</th>
                    <th>Created</th>
                    <th className="th-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {organizations.map((org) => (
                    <tr key={org.org_id}>
                      <td>
                        <div className="org-cell">
                          <div className="org-avatar">
                            {org.org_name?.charAt(0)?.toUpperCase() || 'O'}
                          </div>
                          <div className="org-info">
                            <span className="org-name">{org.org_name}</span>
                            <span className="org-id">{org.org_id}</span>
                          </div>
                        </div>
                      </td>
                      <td>{getPlanBadge(org.plan || org.package_type, org.plan_type)}</td>
                      <td>{getStatusBadge(org)}</td>
                      <td>
                        <div className="users-cell">
                          <UsersIcon /><span>{org.user_count || 0}</span>
                        </div>
                      </td>
                      <td>
                        <div className="date-cell">
                          <CalendarIcon /><span>{formatDate(org.creation_date_and_time)}</span>
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="action-btn-icon btn-view"
                            onClick={() => navigate(`/home/super-admin/organizations/${org.org_id}`)}
                            title="View Details"
                          >
                            <EyeIcon />
                          </button>
                          <button
                            className={`action-btn-icon ${org.is_suspended ? 'btn-activate' : 'btn-suspend'}`}
                            onClick={() => openSuspendModal(org)}
                            title={org.is_suspended ? 'Activate' : 'Suspend'}
                          >
                            {org.is_suspended ? <ActivateIcon /> : <SuspendIcon />}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination footer */}
            <div className="table-footer">
              <div className="pagination-info">
                {total === 0
                  ? 'No records'
                  : `Showing ${firstRecord}–${lastRecord} of ${total}`
                }
              </div>
              <div className="pagination-controls">
                <button
                  className="pagination-btn"
                  disabled={isFirstPage}
                  onClick={() => handlePageChange(1)}
                  title="First page"
                >
                  ««
                </button>
                <button
                  className="pagination-btn"
                  disabled={isFirstPage}
                  onClick={() => handlePageChange(query.page - 1)}
                  title="Previous page"
                >
                  <ChevronLeftIcon />
                </button>
                <span className="pagination-current">
                  Page {query.page} of {totalPages}
                </span>
                <button
                  className="pagination-btn"
                  disabled={isLastPage}
                  onClick={() => handlePageChange(query.page + 1)}
                  title="Next page"
                >
                  <ChevronRightIcon />
                </button>
                <button
                  className="pagination-btn"
                  disabled={isLastPage}
                  onClick={() => handlePageChange(totalPages)}
                  title="Last page"
                >
                  »»
                </button>
              </div>
            </div>
          </>
        )}
      </Card>
      )}

      {/* Suspend/Activate Modal */}
      <Modal
        show={showSuspendModal}
        onHide={() => setShowSuspendModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal-title-custom">
            {selectedOrg?.is_suspended ? 'Activate' : 'Suspend'} Organization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-text">
            Are you sure you want to {selectedOrg?.is_suspended ? 'activate' : 'suspend'}{' '}
            <strong>{selectedOrg?.org_name}</strong>?
          </p>
          {!selectedOrg?.is_suspended && (
            <Form.Group>
              <Form.Label className="form-label-custom">Reason for Suspension</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="form-textarea"
                value={suspendReason}
                onChange={(e) => setSuspendReason(e.target.value)}
                placeholder="Enter reason for suspension..."
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button className="btn-cancel" onClick={() => setShowSuspendModal(false)}>Cancel</Button>
          <Button
            className={selectedOrg?.is_suspended ? 'btn-activate-confirm' : 'btn-suspend-confirm'}
            onClick={handleSuspend}
          >
            {selectedOrg?.is_suspended ? 'Activate' : 'Suspend'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrganizationList;
